export default __webpack_public_path__ + "static/media/i_wdt_c_0.620ae58f.mp3";